import React from 'react';

/* eslint-disable @typescript-eslint/ban-ts-comment */
function isTuiElement (element, tuiNames) {
  return /*#__PURE__*/React.isValidElement(element) &&
  // @ts-ignore
  tuiNames.indexOf(element.type.tuiName) !== -1;
}

export default isTuiElement;
//# sourceMappingURL=is-theme-ui-element.esm.js.map
